import { render, staticRenderFns } from "./TabPrecificacaoDocumento.vue?vue&type=template&id=0043fd14&"
import script from "./TabPrecificacaoDocumento.vue?vue&type=script&lang=js&"
export * from "./TabPrecificacaoDocumento.vue?vue&type=script&lang=js&"
import style0 from "./TabPrecificacaoDocumento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports